export const API_STATUS = "API_STATUS";
export const GET_AUDIT = "GET_AUDIT";
export const GET_CONFIG_AUDIT_TRAIL = "GET_CONFIG_AUDIT_TRAIL";
export const GET_CONFIG_AUDIT_TRAIL_FILTERS = "GET_CONFIG_AUDIT_TRAIL_FILTERS";
export const GET_CONFIG_VERSIONS = "GET_CONFIG_VERSIONS";
